import { ButtonLink, EmptyState, Page } from '@/components/ui';

export function NotFound() {
  return (
    <Page>
      <EmptyState
        icon="explore_off"
        title="This page does not exist"
        action={
          <ButtonLink to="/today" variant="primary">
            Go to Today
          </ButtonLink>
        }
      >
        The link may be out of date, or the item it pointed to was deleted.
      </EmptyState>
    </Page>
  );
}
